import { __decorate, __metadata } from 'tslib';
import { BehaviorSubject } from 'rxjs';
import { Injectable, NgModule } from '@angular/core';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { SpeViewNDetran, SpeJCashOutProxy, SpeNDetran, UiPxDetranModule } from '@wlp/ui-px-detran';
import { UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConsultDetranService = class ConsultDetranService {
    constructor(speViewNAccount, formBuilder) {
        this.speViewNAccount = speViewNAccount;
        this.formBuilder = formBuilder;
        this.consultForm$ = new BehaviorSubject('');
        this.errorMessages = {
            uf: [
                {
                    type: 'required',
                    message: 'Obrigatório!'
                },
            ],
            operation: [
                {
                    type: 'required',
                    message: 'Obrigatório!'
                },
            ],
            renavam: [
                {
                    type: 'required',
                    message: 'Obrigatório!'
                },
                {
                    type: 'minlength',
                    message: 'Tamanho mínimo de 11',
                    param: { minLength: 11 }
                },
            ],
        };
    }
    createForm() {
        return this.formBuilder.group({
            uf: new FormControl(false, Validators.compose([
                Validators.required
            ])),
            operation: new FormControl(false, Validators.compose([
                Validators.required
            ])),
            renavam: new FormControl(false, Validators.compose([
                Validators.minLength(11),
            ])),
        });
    }
    getStates() {
        return this.speViewNAccount.getStates();
    }
    consultType(uf) {
        return this.speViewNAccount.consultYpe(uf);
    }
    getDebits(uf, type, renavam, uuidAccount) {
        return this.speViewNAccount.consultByRenavam(uf, type, renavam, uuidAccount);
    }
    getFormSubject() {
        return this.consultForm$;
    }
    setFormSubject(data) {
        this.consultForm$.next(data);
    }
    getPaymentsType(uuidAccount) {
        return this.speViewNAccount.getPaymentType(uuidAccount);
    }
    getListVehicles(uuidAccountPayment, uuidWhiteLabel) {
        return this.speViewNAccount.getListVehicles(uuidAccountPayment, uuidWhiteLabel);
    }
};
ConsultDetranService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeViewNDetran,
        FormBuilder])
], ConsultDetranService);

let PaymentDetranService = class PaymentDetranService {
    constructor(speJCashOutProxy, formBuilder) {
        this.speJCashOutProxy = speJCashOutProxy;
        this.formBuilder = formBuilder;
        this.errorMessages = {
            paymentType: [
                {
                    type: 'required',
                    message: 'CASH_OUT.DETRAN.FORM_ERROS.REQUIRED'
                },
            ],
            nameCard: [
                {
                    type: 'required',
                    message: 'CASH_OUT.DETRAN.FORM_ERROS.REQUIRED'
                },
            ],
            numberCard: [
                {
                    type: 'required',
                    message: 'CASH_OUT.DETRAN.FORM_ERROS.REQUIRED'
                },
            ],
            validity: [
                {
                    type: 'required',
                    message: 'CASH_OUT.DETRAN.FORM_ERROS.REQUIRED'
                },
            ],
            cvv: [
                {
                    type: 'required',
                    message: 'CASH_OUT.DETRAN.FORM_ERROS.REQUIRED'
                },
            ],
            numberInstallments: [
                {
                    type: 'required',
                    message: 'CASH_OUT.DETRAN.FORM_ERROS.REQUIRED'
                },
            ],
        };
    }
    createForm() {
        return this.formBuilder.group({
            paymentType: new FormControl(false, Validators.compose([
                Validators.required,
                Validators.minLength(10),
            ])),
            nameCard: new FormControl(false, Validators.compose([
                Validators.required,
                Validators.minLength(10),
            ])),
            numberCard: new FormControl(false, Validators.compose([
                Validators.required,
                Validators.minLength(19),
            ])),
            validity: new FormControl(false, Validators.compose([
                Validators.minLength(7),
                Validators.required,
            ])),
            cvv: new FormControl(false, Validators.compose([
                Validators.minLength(3),
                Validators.required,
            ])),
            numberInstallments: new FormControl(false, Validators.compose([
                Validators.minLength(1),
                Validators.required,
            ])),
        });
    }
    getInstallments() {
        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    }
    payment(payment) {
        return this.speJCashOutProxy.payment(payment);
    }
    getErrosMessages() {
        return this.errorMessages;
    }
};
PaymentDetranService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeJCashOutProxy,
        FormBuilder])
], PaymentDetranService);

let CreateVehicleDetranService = class CreateVehicleDetranService {
    constructor(speViewNAccount, formBuilder) {
        this.speViewNAccount = speViewNAccount;
        this.formBuilder = formBuilder;
        this.errorMessages = {
            uf: [
                {
                    type: 'required',
                    message: 'CASH_OUT.DETRAN.FORM_ERROS.REQUIRED'
                },
            ],
            description: [
                {
                    type: 'required',
                    message: 'CASH_OUT.DETRAN.FORM_ERROS.REQUIRED'
                },
            ],
            renavam: [
                {
                    type: 'required',
                    message: 'CASH_OUT.DETRAN.FORM_ERROS.REQUIRED'
                },
            ],
        };
    }
    createForm() {
        return this.formBuilder.group({
            uf: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            description: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            renavam: new FormControl('', Validators.compose([
                Validators.required,
            ])),
        });
    }
    createVehicle(body, uuidAccountPayment, uuidWhiteLabel) {
        let dataRequest = {
            uuidAccountPayment,
            uuidWhiteLabel,
            uf: body.uf,
            description: body.description,
            renavam: body.renavam,
        };
        return this.speViewNAccount.createVehicle(dataRequest);
    }
    deleteVehicle(uuidVehicle) {
        return this.speViewNAccount.deleteVehicle(uuidVehicle);
    }
    getErrosMessages() {
        return this.errorMessages;
    }
};
CreateVehicleDetranService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SpeNDetran,
        FormBuilder])
], CreateVehicleDetranService);

let UiBsDetranModule = class UiBsDetranModule {
};
UiBsDetranModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule,
            UiPxDetranModule
        ],
        providers: [
            ConsultDetranService,
            PaymentDetranService,
            CreateVehicleDetranService
        ]
    })
], UiBsDetranModule);

export { ConsultDetranService, CreateVehicleDetranService, PaymentDetranService, UiBsDetranModule };
//# sourceMappingURL=wlp-ui-bs-detran.js.map
